module.exports = __webpack_public_path__ + "static/media/DefaultBackground.69cc8c6c.jpg";